import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiEndpoints } from "../../services/apiConfig";

// =============================
// 1️⃣ Send OTP (Step 1)
// =============================
export const sendForgotPasswordOtp = createAsyncThunk(
  "forgetPassword/sendOtp",
  async (email, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        apiEndpoints.forgetPassword, // /auth/reset-password
        { email },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to send OTP",
      );
    }
  },
);

// =============================
// 2️⃣ Verify OTP + Reset Password (Step 2)
// =============================
export const verifyForgotPasswordOtp = createAsyncThunk(
  "forgetPassword/verifyOtp",
  async ({ email, otp, newPassword }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        apiEndpoints.resetPassword, // /auth/verify-forgot-password-otp
        {
          email,
          otp,
          new_password: newPassword, // ⚠ important (backend expects snake_case)
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Password reset failed",
      );
    }
  },
);

// =============================
// SLICE
// =============================
const forgetPasswordSlice = createSlice({
  name: "forgetPassword",
  initialState: {
    loading: false,
    error: null,
    success: false,
    message: null,
  },
  reducers: {
    resetForgetPasswordState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    builder

      // 🔄 Send OTP
      .addCase(sendForgotPasswordOtp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendForgotPasswordOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.message = action.payload?.message || "OTP sent successfully";
      })
      .addCase(sendForgotPasswordOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // 🔄 Verify OTP + Reset Password
      .addCase(verifyForgotPasswordOtp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verifyForgotPasswordOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.message =
          action.payload?.message || "Password reset successfully";
      })
      .addCase(verifyForgotPasswordOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetForgetPasswordState } = forgetPasswordSlice.actions;
export default forgetPasswordSlice.reducer;
